import { render, staticRenderFns } from "./ItemsTable.vue?vue&type=template&id=2fe6b81c&scoped=true&"
import script from "./ItemsTable.vue?vue&type=script&lang=js&"
export * from "./ItemsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe6b81c",
  null
  
)

export default component.exports